import { CalendarClockIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { cn } from "utils/cn";
import { ROUTES } from "utils/constants";

import Button from "components/Button";

export default function ExpiredSubscription() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="h-full flex items-center justify-center flex-col w-[465px] mx-auto p-6">
      <div
        className={cn(
          "w-20 h-20 mb-5 rounded-full flex items-center justify-center bg-general-orange-700 border border-general-orange-800",
        )}
      >
        <CalendarClockIcon className="w-10 h-10 stroke-general-orange-900" />
      </div>
      <div className="text-center text-lg font-semibold">{t("home.expiredSubscriptionDialog.title")}</div>
      <div className="text-center mt-4 text-sm">{t("home.expiredSubscriptionDialog.description")}</div>
      <Button className="mt-6 w-full" onClick={() => navigate(ROUTES.CHECKOUT)}>
        {t("home.expiredSubscriptionDialog.choosePackage")}
      </Button>
    </div>
  );
}
